import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import { mapIndustry, mapCountry } from 'tdc-web-backend/enums/enums';
import { useTranslation } from 'react-i18next';
import ControlledTextEditor from '../../../../components/custom-inputs/ControlledTextEditor';
import { TimedProjectEditorMenu } from '../../../../components/editor/menu-option-lists/menu-item-lists';
import Competitors from './Competitors';
import CustomInput from '../../../../components/custom-input/CustomInput';

const About = () => {
  const { t } = useTranslation();
  return (
    <Stack direction="column" spacing={5}>
      <ControlledTextEditor
        label={t('tenders.projectGoals')}
        name="about.goals"
        items={TimedProjectEditorMenu}
        required
      />

      <Box sx={{ display: 'flex' }}>
        <CustomInput
          input={<CustomInput.Autocomplete />}
          sx={{ flex: 1, alignSelf: 'flex-start' }}
          label={t('tenders.targetMarkets')}
          placeholder={t('tenders.selectMarkets')}
          name="about.targetMarkets"
          choices={mapCountry}
          translation={{ t, ns: 'enum' }}
          multiple
          withChips
          fullWidth
          required
        />

        <Divider
          orientation="vertical"
          sx={{ borderColor: '#E5E8FF', margin: '0 24px' }}
          flexItem
        />

        <CustomInput
          input={<CustomInput.Autocomplete />}
          sx={{ flex: 1, alignSelf: 'flex-start' }}
          label={t('tenders.industries')}
          placeholder={t('tenders.selectIndustries')}
          name="about.industries"
          choices={mapIndustry}
          translation={{ ns: 'enum' }}
          multiple
          withChips
          fullWidth
          required
        />
      </Box>

      <ControlledTextEditor
        label={t('tenders.targetAudience')}
        name="about.audience"
        items={TimedProjectEditorMenu}
      />

      <Competitors />
    </Stack>
  );
};

export default About;
